<template>
    <div id="pc">
        <!--导航条 开始-->
        <div class="banner_bg">
            <div class="banner">
                <a class="logo" href="http://www.hengdianworld.com/" target="_blank">
                    <img src="../images/pc/logo1.png" />
                </a>
                <div class="logo_wd">
                    客服中心 <span style="font-size: 12px;">service online</span> <br>
                    <span style="font-size: 18px;">4009057977</span>
                </div>
                <ul class="links">
                    <li>
                        <a href="http://www.hengdianworld.com/AboutUs.aspx" target="_blank">
                            关于横店
                        </a>
                    </li>
                    <li>
                        <a href="http://www.hengdianworld.com/BizMeetings.aspx" class="arightborder" target="_blank">
                            商旅会务
                        </a>
                    </li>
                    <li>
                        <a href="http://e.hengdianworld.com/" class="arightborder" target="_blank">
                            在线预订
                        </a>
                    </li>
                    <li>
                        <a href="http://www.hengdianworld.com/TripPlan.aspx" class="arightborder" target="_blank">
                            旅游攻略
                        </a>
                    </li>
                    <li>
                        <a href="http://www.hengdianworld.com/FilmSet.aspx" class="arightborder" target="_blank">
                            影视片场
                        </a>
                    </li>
                    <li>
                        <a href="http://www.hengdianworld.com/CrewService.aspx" class="arightborder" target="_blank">
                            剧组服务
                        </a>
                    </li>
                    <li>
                        <a href="http://www.hengdianworld.com/ArtPerformance.aspx" class="arightborder" target="_blank">
                            演艺活动
                        </a>
                    </li>
                    <li>
                        <a href="http://www.hengdianworld.com/Scenic.aspx" class="arightborder" target="_blank">
                            旅游景区
                        </a>
                    </li>
                    <li>
                        <a href="http://www.hengdianworld.com/Default.aspx" class="arightborder" target="_blank">
                            首页
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <!--导航条 结束-->
        <!--加载栏-->
        <div class="loading">
            <div class="pic"></div>
        </div>

        <!-- 内容 -->
        <div class="" style="height: 5000px;width: 790px;left: 50%; transform: translate(-50%,0);position: absolute;" >
            <div class="" style="position: absolute;left:50%;width: 1920px;right: auto;">
                <div style="position: absolute;left:-960px;right: auto;width: 1920px;">
                    <router-link to="/yxmhPC" target="_blank">
                        <div class="btn3">
                            <img src="../images/pc/button3.png" alt="">
                        </div>
                    </router-link>
                    <router-link to="/jnmhPC" target="_blank">
                        <div class="btn3 btn4">
                            <img src="../images/pc/button3.png" alt="">
                        </div>
                    </router-link>
                    <img src="../images/pc/1.jpg" alt="">
                    <img src="../images/pc/2.jpg" alt="">
                    <img src="../images/pc/3.jpg" alt="" usemap="#Map">
                    <map name="Map">
                        <area shape="rect" coords="734,567,944,725" href="http://e.hengdianworld.com/VisitorTicketActivity.aspx?id=559" target="_blank">
                        <area shape="rect" coords="1254,564,1440,722" href="http://e.hengdianworld.com/VisitorTicketActivity.aspx?id=560" target="_blank">
                    </map>
                    <img src="../images/pc/4.jpg" alt="" usemap="#Map2">
                    <map name="Map2">
                        <area shape="rect" coords="1084,733,1394,936" href="http://e.hengdianworld.com/visitorPackageActivity.aspx?id=7" target="_blank">
                        <area shape="rect" coords="1088,1397,1415,1585" href="http://e.hengdianworld.com/visitorPackageActivity.aspx?id=11" target="_blank">
                        <area shape="rect" coords="715,1595,1206,1731" href="http://e.hengdianworld.com/" target="_blank">
                    </map>
                </div>

            </div>
        </div>

        <!-- WPA Button Begin -->
        <div id="QQbar" style="position:fixed ; top:50%; right:10px; width:120px; height:160px; margin-top:-80px; z-index:99; ">
            <a href="#" onClick="ysf.open();return false;"> <img style="width:100%" src="../images/pc/zx.png" /></a>

        </div>
    </div>
</template>

<script>
    import '../css/nav.css'
    import '../utils/762336eee6f3d299d818075a902ebc61'
    import '../utils/snow-plugin'
    export default {
        name: "pcView",
        data: function () {
            return {
                noshow: true,
            }
        },
        components: {
        },
        methods: {
            showvideo: function () {
                let videoBox = this.$refs.videoBox
                this.noshow = !this.noshow;
                if(this.noshow){
                    videoBox.pause();
                }else {
                    videoBox.play();
                }
            }
        },
        mounted: function () {
            let _this = this;
            this.$refs.videoBox.addEventListener('ended', function () {
                _this.noshow = !_this.noshow
            });

        }
    }
</script>

<style scoped lang="scss">
#pc {
    img {
        margin:0;
        padding: 0;
        display: block;
    }
    area {
        outline: none;
    }
    .btn3 {
        position: absolute;
        top: 1847px;
        left: 510px;
    }
    .btn4 {
        top: 2070px;
    }
}
</style>